// 3rd party
import * as React from 'react';

// Components
import { WidgetPreviewFrameStyles } from 'components/package/expedia/interfaces';

interface ExpediaPackageWidgetPreviewFrameProps {
  link: string;
  styles: WidgetPreviewFrameStyles;
}

const ExpediaPackageWidgetPreviewFrame = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function ExpediaPackageWidgetPreviewFrame(props: ExpediaPackageWidgetPreviewFrameProps): JSX.Element {
    const { link, styles } = props;

    return (
      <div key={link} id="packageDealsWidget" style={styles}>
        <iframe id="widgetIframe" src={link} width="100%" height="100%" frameBorder="0" scrolling="no" tabIndex={-1} />
      </div>
    );
  },
);

export { ExpediaPackageWidgetPreviewFrame };
